export const DEFAULT_TENANT_ID = 'saashr';